module.exports = __webpack_public_path__ + "static/wookie-3b043b04eb4f7fcfa4d83f63b948b322.jpg";